export const AuthHeadDesc = ({
  classNameHeader = "",
  classNameDescription = "",
  title,
  description,
}) => {
  return (
    <>
      {title ? (
        <h2 className={`${classNameHeader ? classNameHeader : ""} auth__title`}>
          {title}
        </h2>
      ) : (
        ""
      )}
      {description ? (
        <p
          className={`${
            classNameDescription ? classNameDescription : ""
          } auth__desc`}
        >
          {description}
        </p>
      ) : (
        ""
      )}
    </>
  );
};

export default AuthHeadDesc;
